<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title>
        <h2>{{ title }}</h2>

        <v-spacer />

        <v-icon
          aria-label="Close"
          @click="cancel"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text class="pt-6 black--text">
        <slot name="content" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!isEdit && !isConfirm"
          color="success"
          dark
          @click="save"
        >
          추가
        </v-btn>

        <v-btn
          v-if="isEdit && !isConfirm"
          color="orange"
          dark
          @click="edit"
        >
          수정
        </v-btn>

        <v-btn
          v-if="!isConfirm"
          @click="cancel"
        >
          취소
        </v-btn>
        <v-btn
          v-if="isConfirm"
          color="primary"
          dark
          @click="save"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'CustomDialog',
    props: {
      title: {
        type: String,
      },
      maxWidth: {
        type: Number,
        default: 350,
      },
      dialog: {
        type: Boolean,
        default: false,
      },
      toParent: {
        type: Function,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      isConfirm: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      save () {
        this.toParent('save')
      },
      edit () {
        this.toParent('edit')
      },
      cancel () {
        this.toParent('cancel')
      },
    },
  }
</script>

<style scoped>

</style>
